import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import Rellax from 'rellax';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';

import '../blocks/header/header';
import '../blocks/portfolio/portfolio';


$(function () {
	svg4everybody();

	if (typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined') {
		document.documentElement.className += 'mix-blend-mode-no';
	}

	const addParallaxLayers = () => {
		const $cubesWrapper = document.querySelector('.js-cubes-layer-wrapper');
		const $cubesLayer = document.querySelector('.js-cubes-layer');

		while (document.body.clientHeight > $cubesWrapper.clientHeight) {
			const $newEl = $cubesLayer.cloneNode(true);
			$cubesWrapper.insertBefore($newEl, $cubesLayer);
		}
	};

	addParallaxLayers();

	const rellax = new Rellax('.js-rellax', { // eslint-disable-line no-new
		center: true
	});

	window.onresize = function () {
		addParallaxLayers();

		rellax.refresh();
	};
});



// WEBPACK FOOTER //
// ./app/scripts/app.js